/* @flow */

export const LOG_PREFIX = `paypal_legacy`;

export const ATTRIBUTES = {
    BUTTON:      'data-paypal-button',
    MERCHANT_ID: 'data-paypal-id',
    ENV:         'data-env',
    SANDBOX:     'data-sandbox'
};

export const CLASSES = {
    HIDDEN_BUTTON: 'paypal-button-hidden'
};



// WEBPACK FOOTER //
// ./src/legacy/constants.js